<template>
	<span class="n-avatar" :class="`n-avatar--${size}`" :style="bg" :title="name">
		<img v-if="src && !failed" :src="src" :alt="name" @error="failed = true">
		<span v-else class="n-avatar__initials">{{ initials }}</span>
	</span>
</template>

<script setup>
import { ref, computed } from 'vue';

const props = defineProps({
	src: { type: String, default: '' },
	name: { type: String, default: '' },
	size: { type: String, default: 'md' }, // sm | md | lg
});

const failed = ref(false);

const initials = computed(() => {
	const n = (props.name || '').trim();
	if (!n) return '?';
	const parts = n.split(/\s+/);
	if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
	return (parts[0][0] + parts[1][0]).toUpperCase();
});

// deterministic color from the name
const colors = ['#1b55e3', '#ff8200', '#17c964', '#5b3cc4', '#f2135d', '#06b6d4'];
const bg = computed(() => {
	if (props.src && !failed.value) return {};
	let h = 0;
	for (let i = 0; i < (props.name || '').length; i += 1) h = (h * 31 + props.name.charCodeAt(i)) % 100000;
	return { background: colors[h % colors.length] };
});
</script>

<style scoped>
.n-avatar {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	border-radius: 50%;
	overflow: hidden;
	color: #fff;
	font-weight: 700;
	flex: none;
	box-shadow: 0 0 0 2px #fff;
}
.n-avatar img { width: 100%; height: 100%; object-fit: cover; }
.n-avatar--sm { width: 24px; height: 24px; font-size: 10px; }
.n-avatar--md { width: 32px; height: 32px; font-size: 12px; }
.n-avatar--lg { width: 40px; height: 40px; font-size: 14px; }
</style>
